<template>
  <div class="categories-view">
    <section class="site-hero category-hero">
      <div class="site-hero__inner">
        <div class="crumb-row">
          <router-link class="crumb-link" to="/core-business">返回核心业务</router-link>
        </div>
        <h1>{{ business ? business.title : "核心业务分类" }}</h1>
        <p>{{ business ? business.summary : "根据业务模块展示对应的产品分类列表，便于客户先按大类理解服务，再进入具体产品详情页查看适用企业与办理流程。" }}</p>
      </div>
    </section>

    <section class="page-section content-section">
      <div class="page-head">
        <div><h2>分类列表</h2></div>
      </div>
      <div class="page-shell">
        <el-empty v-if="!business" description="未找到对应业务分类，请返回核心业务重新选择。" />
        <div v-else class="category-grid">
          <router-link
            v-for="(item, index) in business.categories"
            :key="item.slug"
            class="category-link"
            :to="{ path: '/business-detail', query: { business: businessKey, item: item.slug } }"
          >
            <article class="category-card panel-card" :class="categoryTone(index)">
              <h3>{{ item.title }}</h3>
              <!-- <p>{{ item.subtitle }}</p> -->
              <div class="card-foot">
                <span>{{ item.subtitle }}</span>
                <i class="el-icon-right"></i>
              </div>
            </article>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getBusinesses } from "@/api/website";

export default {
  name: "BusinessCategoriesView",
  data() {
    return {
      businesses: {}
    };
  },
  computed: {
    businessKey() {
      return this.$route.query.business;
    },
    business() {
      return this.businesses[this.businessKey] || null;
    }
  },
  created() {
    getBusinesses().then((res) => {
      this.businesses = res.data || {};
    });
  },
  methods: {
    categoryTone(index) {
      return `category-card--tone-${index % 6}`;
    }
  }
};
</script>

<style lang="less" scoped>
.category-hero {
  background:
    linear-gradient(90deg, rgba(3, 23, 50, 0.94) 0%, rgba(7, 55, 105, 0.74) 48%, rgba(12, 83, 146, 0.34) 100%),
    url("/assets/banner.png") center / cover no-repeat;
}

.content-section {
  background: var(--soft-blue);
}

.page-shell {
  width: min(1280px, 100%);
  margin: 0 auto;
}

.crumb-row {
  margin-bottom: 22px;
}

.crumb-link {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  color: var(--white);
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.category-link {
  display: block;
}

.category-card {
  position: relative;
  height: 100%;
  padding: 24px;
  overflow: hidden;
  border-color: rgba(29, 104, 199, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.category-link:hover .category-card {
  transform: translateY(-4px);
  box-shadow: 0 20px 42px rgba(8, 43, 84, 0.12);
}

.category-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 5px;
  background: var(--category-accent);
}

.category-card--tone-0 {
  --category-accent: #1d68c7;
  background: linear-gradient(135deg, #ffffff 0%, #eaf4ff 100%);
}

.category-card--tone-1 {
  --category-accent: #2f9e83;
  background: linear-gradient(135deg, #ffffff 0%, #e9f8f3 100%);
}

.category-card--tone-2 {
  --category-accent: #d68a18;
  background: linear-gradient(135deg, #ffffff 0%, #fff5e5 100%);
}

.category-card--tone-3 {
  --category-accent: #6c63c7;
  background: linear-gradient(135deg, #ffffff 0%, #f0efff 100%);
}

.category-card--tone-4 {
  --category-accent: #2786a8;
  background: linear-gradient(135deg, #ffffff 0%, #e9f7fb 100%);
}

.category-card--tone-5 {
  --category-accent: #c45f77;
  background: linear-gradient(135deg, #ffffff 0%, #fff0f3 100%);
}

.category-card b {
  color: var(--blue);
  font-size: 12px;
}

.category-card h3 {
  margin: 14px 0 10px;
  font-size: 26px;
}

.category-card p {
  margin: 0;
  color: var(--muted);
}

.card-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  color: var(--navy);
  font-weight: 700;
}

@media (max-width: 1040px) {
  .category-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .crumb-link {
    min-height: 34px;
    padding: 0 12px;
    font-size: 13px;
  }

  .category-card {
    padding: 20px;
  }

  .category-card h3 {
    margin-top: 0;
    font-size: 21px;
  }

  .category-card p,
  .card-foot {
    font-size: 14px;
  }
}
</style>
